import {
  REQUESTTIME_WITHDRAW_FETCHING,
  REQUESTTIME_WITHDRAW_SUCCESS,
  REQUESTTIME_WITHDRAW_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REQUESTTIME_WITHDRAW_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case REQUESTTIME_WITHDRAW_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case REQUESTTIME_WITHDRAW_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
